export const CONTACT_TYPE_ID = '0-1';
export const COMPANY_TYPE_ID = '0-2';
export const DEAL_TYPE_ID = '0-3';
export const SUBMISSION_TAG_TYPE_ID = '0-119';
export const TICKET_TYPE_ID = '0-5';
export const SOCIAL_CHANNEL_TYPE_ID = '0-36';
export const AUTOMATION_PLATFORM_FLOW_ID = '0-44';
export const OBJECT_LIST_TYPE_ID = '0-45';
export const WEB_INTERACTIVE_TYPE_ID = '0-91';